import React, { useEffect } from 'react'
import { Box, Grid, useTheme, Stack, IconButton, Tooltip, Typography } from "@mui/material";
import { tokens } from "../../../assets/theme";
import { useLocalStorage } from '../../../hooks/useLocalStorage';
import { getTimespan } from "../../../fetchers/timespan";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import SensorDataDiagram from './sensorDataDiagram';
import CircularProgress from "@mui/material/CircularProgress";
import { fetchMachineSensorData } from "../../../fetchers/sensorData";
import DateFilter from "./DateFilter";
import { getGanttDataMachine } from "../../gantt/hooks/fetchers"
import useFeatureFlags from "../../../hooks/useFeatureFlags";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import { useNavigate } from 'react-router-dom';
import { fetchReadingAllThresholdsForMachine } from "../../../fetchers/readingthreshold";
import { HideIfNoRole } from "../../../auth/authUi";

export default function SensorData(props) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);

    const navigate = useNavigate();
    const featuresQuery = useFeatureFlags();

    const sensorDataQuery = useQuery(
        ["sensorData", props.machineId, props.timespan],
        () => fetchMachineSensorData(props.machineId, props.timeSpanStartDate, props.timeSpanEndDate),
        {
            staleTime: 60000,
            refetchInterval: 60000,
            keepPreviousData: true
        }
    );

    const ganttQuery = useQuery(
        ["gantt", props.machineId],
        () => getGanttDataMachine(props.machineId),
        {
            staleTime: 60000,
            refetchInterval: 60000,
            keepPreviousData: true
        }
    );

    const thresholdQuery = useQuery(
        ["thresholds", props.machineId],
        () => fetchReadingAllThresholdsForMachine(props.machineId),
        {
            staleTime: 60000,
            refetchInterval: 60000,
            keepPreviousData: true
        }
    );

    if (sensorDataQuery.isLoading || sensorDataQuery.isError
        || ganttQuery.isLoading || ganttQuery.isError
        || featuresQuery.isLoading || featuresQuery.isError
        || thresholdQuery.isLoading || thresholdQuery.isError) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <CircularProgress color="secondary" />
            </Box>
        );
    }


    return (
        <Box sx={{ color: "white", minHeight: props.tabExpanded ? "69vh" : "50vh" }}>

            <Box sx={{ backgroundColor: colors.primary[400], color: "white", p: 1, minHeight: props.tabExpanded ? "69vh" : "50vh" }}>
                <Grid item xs={2} lg={8} sx={{ mt: 0 }}>
                    <Box width={1} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mt: 1 }}>
                        <HideIfNoRole anyOf={[1, 2]}>
                            <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.settingsButtonTooltip} /></Typography>}>
                                <IconButton aria-label="sensor data settings" size="large" onClick={() => { navigate('/sensorDataDiagramSettings/' + props.machineId); }}>
                                    <SettingsOutlinedIcon fontSize="inherit" />
                                </IconButton>
                            </Tooltip>
                        </HideIfNoRole>
                    </Box>
                </Grid>
                <Grid container spacing={3}>
                    {/* Header */}
                    <Grid item xs={12}>
                    </Grid>
                    <SensorDataDiagram
                        sensorDataQuery={sensorDataQuery}
                        fromDate={props.timeSpanStartDate}
                        toDate={props.timeSpanEndDate}
                        ganttQueryData={ganttQuery.data}
                        ganttStartDate={props.startDate}
                        ganttEndDate={props.endDate}
                        featureFlags={featuresQuery?.data}
                        thresholds={thresholdQuery?.data} />
                </Grid>
            </Box>
        </Box>
    )


};



